// src/context/UserContext.tsx
import React, { createContext, useCallback, useContext, useState } from 'react';
import { userService } from 'services';
import type { IUser } from 'types/User';

interface UserContextType {
  user: IUser | null;
  setUser: React.Dispatch<React.SetStateAction<IUser | null>>;
  /** Recharge le profil depuis l'API et retourne l'utilisateur à jour. */
  fetchUser: () => Promise<IUser | null>;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<IUser | null>(null);

  const fetchUser = useCallback(async (): Promise<IUser | null> => {
    const userConnected = await userService.getUserConnected();
    if (userConnected.success && userConnected.data.length > 0) {
      const nextUser = userConnected.data[0];
      setUser(nextUser);
      return nextUser;
    }
    return null;
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, fetchUser }}>
      {children}
    </UserContext.Provider>
  );
};
